export default [
    // 首页
    {
        path: '/home',
        component: () =>
            import(
                /* webpackChunkName: 'home' */ '../components/pages/views/home/home.vue'
            ),
    },
    // 公司概况
    {
        path: '/companyIntro',
        component: () =>
            import(
                /* webpackChunkName: 'companyIntro' */ '../components/pages/views/aboutUs/companyIntro.vue'
            ),
    },
    // 公司文化
    {
        path: '/culture',
        component: () =>
            import(
                /* webpackChunkName: 'culture' */ '../components/pages/views/aboutUs/culture.vue'
            ),
    },
    // 合作伙伴
    {
        path: '/partner',
        component: () =>
            import(
                /* webpackChunkName: 'partner' */ '../components/pages/views/aboutUs/partner.vue'
            ),
    },
    {
        path: '/Partner.html',
        redirect: '/partner',
    },
    // 招才纳贤
    {
        path: '/recruit',
        component: () =>
            import(
                /* webpackChunkName: 'recruit' */ '../components/pages/views/aboutUs/recruit.vue'
            ),
    },
    // 联系我们
    {
        path: '/contactUs',
        component: () =>
            import(
                /* webpackChunkName: 'contactUs' */ '../components/pages/views/aboutUs/contactUs.vue'
            ),
    },
    // 关于我们
    {
        path: '/aboutus',
        component: () =>
            import(
                /* webpackChunkName: 'contactUs' */ '../components/pages/views/aboutUs/aboutus.vue'
            ),
    },
    {
        path: '/Contact.html',
        redirect: '/contactUs',
    },
    // 资质证书
    {
        path: '/certificate',
        component: () =>
            import(
                /* webpackChunkName: 'certificate' */ '../components/pages/views/certificate/certificate.vue'
            ),
    },
    {
        path: '/certificate/:id',
        component: () =>
            import(
                /* webpackChunkName: 'certificate' */ '../components/pages/views/certificate/certificate.vue'
            ),
    },
    // 精品案例列表
    {
        path: '/caseDetail/:id',
        component: () =>
            import(
                /* webpackChunkName: 'caseDetail' */ '../components/pages/views/case/caseDetail.vue'
            ),
    },
    {
        path: '/case',
        component: () =>
            import(
                /* webpackChunkName: 'case' */ '../components/pages/views/case/case.vue'
            )
    },
    {
        path: '/case/:id',
        component: () =>
            import(
                /* webpackChunkName: 'case' */ '../components/pages/views/case/case.vue'
            ),
        props: true 
    },
    // 精品案例详情
    {
        path: '/caseDetail',
        component: () =>
            import(
                /* webpackChunkName: 'caseDetail' */ '../components/pages/views/case/caseDetail.vue'
            ),
    },
    // 产品中心列表
    {
        path: '/product',
        component: () =>
            import(
                /* webpackChunkName: 'product' */ '../components/pages/views/procuct/product.vue'
            )
    },
    {
        path: '/product/:id',
        component: () =>
            import(
                /* webpackChunkName: 'product' */ '../components/pages/views/procuct/product.vue'
            ),
            props: true 
    },
    // 软件产品列表
    {
        path: '/softProduct',
        component: () =>
            import(
                /* webpackChunkName: 'softProduct' */ '../components/pages/views/procuct/softProduct/softProduct.vue'
            ),
    },
    // 新闻中心列表
    {
        path: '/newsList/:id',
        component: () =>
            import(
                /* webpackChunkName: 'newsList' */ '../components/pages/views/news/news.vue'
            ),
    },
    // 新闻中心详情
    {
        path: '/newsDetail/:id/:type',
        component: () =>
            import(
                /* webpackChunkName: 'newsDetail' */ '../components/pages/views/news/newsDetail.vue'
            ),
    },
    // 重定向组件
    {
        path: '/news/:id',
        component: () =>
            import(
                /* webpackChunkName: 'location' */ '../components/pages/commonComponents/newsLocation.vue'
            ),
    },
    {
        path: '/intro/:id',
        component: () =>
            import(
                /* webpackChunkName: 'location' */ '../components/pages/commonComponents/introLocation.vue'
            ),
    },
]
